
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'
import ColorModeSwitcher from '@/common/components/ui/ColorModeSwitcher.vue'

export default defineComponent({
    name: 'TheHeader',
    components: {
        ColorModeSwitcher,
    },
    setup() {
        const store = useStore()

        const menuState = computed(() => store.getters['ui/menuState'])

        return {
            menuState,
        }
    },
})
